class GroupFilter {
  public buttons: NodeListOf<HTMLElement>;
  public groupLinks: NodeListOf<HTMLElement>;

  private prevQueryString: string = '';
  private currentQueryString: string = '';

  handleFilterChange(e: Event) {
    if ((e.currentTarget as HTMLElement).classList.contains('a-filter-pill--selected')) return;

    const list = (e.currentTarget as HTMLElement).dataset.listId as string;
    const url = new URL(window.location as unknown as string);

    url.searchParams.set('group', list);
    url.hash = '';
    window.history.pushState({}, '', url as unknown as string);
    window.location.reload();
  }

  private handlePopstate() {
    window.location.reload();
  }

  private updateCurrentQueryString() {
    this.currentQueryString = this.prevQueryString;
  }

  private updatePrevQueryString() {
    this.prevQueryString = window.location.search;
  }

  private isSamePageParams() {
    const newQueryString = window.location.search;
    return this.currentQueryString === newQueryString;
  }

  bindings() {
    if (this.buttons) {
      this.buttons.forEach((button) => {
        button.addEventListener('click', this.handleFilterChange.bind(this));
      });
    }

    // Note:
    // This valid validation is done because the the consent banner
    // is listeng for the same 'popstate' event to be displayed
    // and we need it here because when the user go back on the history
    // we just want to check if the url changes (url params) and trigger the window reload
    this.updatePrevQueryString();
    this.updateCurrentQueryString();
    window.addEventListener('popstate', (e) => {
      this.updateCurrentQueryString();
      if (this.isSamePageParams() === false ) {
        this.handlePopstate()
      }
    });

    if (this.groupLinks) {
      this.groupLinks.forEach((link) => {
        link.addEventListener('click', (e: Event) => {
          const target = e.target as HTMLElement;

          if (target.tagName.toLowerCase() === 'img' || target.classList.contains('m-wishlist-group-teaser__title')) {
            const targetEl = e.currentTarget as HTMLElement;

            const listId = (targetEl.closest('.m-wishlist-group-teaser') as HTMLElement | null)?.dataset.listId as string;
            const url = new URL(window.location as unknown as string);

            url.searchParams.set('group', listId);
            url.hash = '';
            window.history.pushState({}, '', url as unknown as string);
            window.location.reload();
          }
        });
      });
    }
  }

  cache() {
    this.buttons = document.querySelectorAll('.m-wishlist-group-filter .a-filter-pill');
    this.groupLinks = document.querySelectorAll('.o-wishlist-group-teaser .m-wishlist-group-teaser__img-wrap, .o-wishlist-group-teaser .m-wishlist-group-teaser__title');
  }

  init() {
    this.cache();
    this.bindings();
  }
}

export default GroupFilter;
